document.addEventListener("DOMContentLoaded", function () {
  const allSwiper = document.querySelectorAll(".swiper-testimonials");

  allSwiper.forEach((element) => {
    const wrapper = element.parentElement;
    const {
      arrow,
      itemsDesktop,
      itemsTablet,
      itemsMobile,
      itemsDesktopXl,
      pagination,
    } = wrapper.dataset;
    const itemsDesktop2xl = wrapper.getAttribute("data-items-desktop-2xl");

    let options = {
      loop: true,
      slidesPerView: itemsMobile,
      spaceBetween: 29,
      breakpoints: {
        640: {
          slidesPerView: itemsTablet,
        },
        1024: {
          slidesPerView: itemsDesktop,
        },
        1440: {
          slidesPerView: itemsDesktopXl,
        },
        1720: {
          slidesPerView: itemsDesktop2xl,
        },
      },
    };

    if (pagination === "true") {
      options = {
        ...options,
        pagination: {
          el: ".swiper-pagination-custom",
          clickable: true,
        }
      };
    }

    if (arrow === "true") {
      options = {
        ...options,
        navigation: {
          nextEl: ".slider-button.slider-button--next",
          prevEl: ".slider-button.slider-button--prev",
        },
      };
    }

    new Swiper(element, options);
  });
});
